import React from 'react'
import { injectIntl } from 'react-intl'
import { BaseDetailDiagram } from './DetailDiagram'
import { getComponentPartitions } from './partitions'
import { useComponentDetailDiagramGraph } from './hooks'
import { Loadable } from '../components/Loading'

const ComponentDetailDiagram = ({
  intl,
  vin,
  subsystemCode,
  component,
  pins,
  hideNotConnectedPins = true,
  hideInlineEdges = true,
  theme = null,
  zoomControlClassName = 'detail-diagram-zoom-control',
}) => {
  const { isSuccess, isLoading, detailDiagramViewGraph } =
    useComponentDetailDiagramGraph({
      vin,
      subsystemCode,
      componentId: component,
      pins,
    })

  return (
    <Loadable showText={false} isLoading={isLoading || !isSuccess}>
      <BaseDetailDiagram
        intl={intl}
        graph={detailDiagramViewGraph}
        hideNotConnectedPins={hideNotConnectedPins}
        hideInlineEdges={hideInlineEdges}
        getPartitions={(graph) => getComponentPartitions(graph, component)}
        nodeLayoutOptions={({ node, partitionMapping }) => ({
          'org.eclipse.elk.partitioning.partition': partitionMapping[node.id()],
        })}
        prioritizeInlineEdges={true}
        theme={theme}
        zoomControlClassName={zoomControlClassName}
      />
    </Loadable>
  )
}

export default injectIntl(ComponentDetailDiagram)
